beforeSubmitProductSelect = function (target) {
    const article = target.closest('article');

    const radio = article.querySelector('.product-teaser-radio input');
    radio.checked = true;

    const form = target.closest('form');
    form.querySelector('.form-navigation .next button').click();
};
